<modal *ngIf="location"
       headerText="Add/Edit marker {{location.name}}"
       [showClose]="true"
       [show]="show"
       (onClose)="cancel()"
       [large]="true">
    <div class="modal-body">
        <div class="form-group"
             *ngIf="location">
            <div class="row">
                <div class="col-md-12 col-12">
                    <label class="input-label field-required">{{ 'name' | translate }}</label>
                    <input class="form-control"
                           type="text"
                           name="name"
                           [(ngModel)]="location.name"
                           [rangeLength]="[2, 256]"
                           required
                           autofocus>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-md-12 col-12">
                    <label class="input-label field-required">{{ 'address' | translate }}</label>
                    <input class="form-control"
                           type="text"
                           name="address"
                           [(ngModel)]="location.address"
                           [rangeLength]="[2, 256]"
                           required
                           autofocus>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-md-12 col-12">
                    <label class="input-label field-required">{{ 'phone' | translate }}</label>
                    <input class="form-control"
                           type="text"
                           name="phone"
                           [(ngModel)]="location.phone"
                           [rangeLength]="[2, 256]"
                           required
                           autofocus>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-md-12 col-12">
                    <label class="input-label field-required">{{ 'email' | translate }}</label>
                    <input class="form-control"
                           type="text"
                           name="email"
                           [(ngModel)]="location.email"
                           [rangeLength]="[2, 256]"
                           required
                           autofocus>
                </div>
            </div>
        </div>
        <div>
            <primary-text-button [noLeftPadding]="true"
                                 (click)="save()">{{ 'Save' | translate }}</primary-text-button>
            <primary-text-button (click)="cancel()">{{ 'Cancel' | translate }}</primary-text-button>
            <cancelary-text-button (click)="delete()">{{ 'general.delete' | translate }}</cancelary-text-button>
        </div>
    </div>
</modal>
